module.exports = __webpack_public_path__ + "static/media/QH.63afa62b.png";